import { Component, effect } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { BaseComponent } from '../../components/base.component';
import { OnboardingContainerComponent } from '../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, TranslocoPipe],
  templateUrl: './redirect.component.html',
  standalone: true,
})
export class RedirectComponent extends BaseComponent {
  constructor() {
    super();

    effect(() => {
      const childOnboardingsLoaded = this.store.childOnboardingsLoaded();
      const childOnboardingsLoading = this.store.childOnboardingsLoading();

      if (!childOnboardingsLoading && childOnboardingsLoaded) {
        this.service.redirectToNextStep(true);
      }
    });
  }

  protected override submit(): void {
    // Nothing to do
  }

  protected override populateFromData(): void {
    // Nothing to do
  }

  protected override listenToSuccessfulSubmit(): void {
    // Nothing to do
  }
}
